import { CreditDetail, TravelWalletCredit, TravelWalletOffer } from "./wallet";

export interface LandingPageTakeovers {
  takeovers: Takeover[];
  walletTakeover: Takeover;
  statusTakeover?: Takeover;
}

export interface TravelWalletTakeover {
  Takeover: TakeoverEnum.TravelWalletTakeover;
  offerCount: number;
  creditBreakdown: CreditDetail[];
  bestOffer?: TravelWalletOffer;
  credit?: TravelWalletCredit;
}

export interface StatusTakeover {
  Takeover: TakeoverEnum.StatusTakeover;
  message: string;
}

export type Takeover =
  | TravelWalletTakeover
  | StatusTakeover;

export enum TakeoverEnum {
  TravelWalletTakeover = "TravelWalletTakeover",
  StatusTakeover = "StatusTakeover",
}
